import React from "react";
import LeloFormCard from "./LeloFormCard";

const LeloCards = ({ items }) => {
  console.log("LeloCards items:", items); // Log the items prop to check its value
  return (
    <div className="interest-form-grid">
      {items.map((item) => {
        return <LeloFormCard info={item} />;
      })}
    </div>
  );
};

export default  LeloCards;
